export enum WorkOutcome {
  DISABLED = 'disabled',
  DISPATCHED = 'dispatched',
  ERROR = 'error',
  SUCCESS = 'success',
  TIMEOUT = 'timeout',
}
